import { render } from "./Contacts.vue?vue&type=template&id=45f23e00&scoped=true&ts=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"

import "./Contacts.vue?vue&type=style&index=0&id=45f23e00&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f23e00"]])

export default __exports__